import { Component } from '@angular/core';

@Component({
  selector: 'item-progress',
  templateUrl: 'item-progress.html',
  styleUrls: ['item-progress.scss']
})
export class ItemProgressComponent {}
